export default __webpack_public_path__ + "static/media/resourceelumnt3.36d0d951.jpg";